import { useEffect, useState, useContext } from "react";
import Services from "../components/Services";

/*-----Hoja de estilo-----*/
import "../styles/home.css";

/*-----Iconos-----*/
import {
  MdLocalAtm,
  MdOutlineWifiPassword,
  MdOutlinePowerOff,
  MdOutlineWifiOff,
  MdNetworkCheck,
  MdOutlineFactory,
  MdStore,
} from "react-icons/md";
import { SiGoogleplay } from "react-icons/si";
import { IoAlertCircleOutline, IoLogoAppleAppstore } from "react-icons/io5";
import { FaChevronRight, FaWifi } from "react-icons/fa";
import { RiMedalLine } from "react-icons/ri";
import { http } from "../auth";

/*-----Imagenes-----*/
import imgInicio from "../static/img/imgInicio.svg";
import { AiOutlineGlobal } from "react-icons/ai";
import { useThemeManager } from "../Hooks/ThemeManager";
import { useNavigate } from 'react-router-dom';
import { FiAlertTriangle } from 'react-icons/fi';
import { GoAlertFill } from "react-icons/go";

const Home = () => {
  const { themeColors } = useThemeManager();
  const [loading, setLoading] = useState(false);
  const [dataServ, setDataServ] = useState(null);
  const token = localStorage.getItem("token");
  const [selectedServ, setSelectedServ] = useState(null);
  let userName = localStorage.getItem("userName");
  const navigate = useNavigate();

  const fetchData = () => {
    setLoading(true);
    http
      .get("/juridico/client-profile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setDataServ(response.data);
        sessionStorage.setItem("dataServ", JSON.stringify(response.data));
        localStorage.setItem("ID", response.data.usuario[0].id);
        localStorage.setItem("userName", response.data.usuario[0].nombre_empresa);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error en la solicitud:", error);
        setLoading(false);
      });
  };

  function capitalize(str) {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const handleSelectServ = (serv, letter) => {
    serv.letter = letter;
    setSelectedServ(serv);
    localStorage.setItem("selectedServ", JSON.stringify(serv));
  };

  const handleBack = () => {
    setSelectedServ(null);
    localStorage.removeItem("selectedServ");
  };

  // Leer el estado de localStorage cuando se carga el componente
  useEffect(() => {
    fetchData();
    const storedDataServ = sessionStorage.getItem("dataServ");
    if (storedDataServ) {
      setDataServ(JSON.parse(storedDataServ));
    }
    const storedServ = localStorage.getItem("selectedServ");
    if (storedServ) {
      setSelectedServ(JSON.parse(storedServ));
    }
  }, []);

  return (
    <div className="contenedorHome">
      {!selectedServ && (
        <div className="bienvenida responsive">
          <span>Bienvenido nuevamente,</span>
          <span>{userName}</span>
        </div>
      )}
      {selectedServ ? (
        <Services
          data={selectedServ}
          setSelectedServ={setSelectedServ}
          handleBack={handleBack}
          capitalize={capitalize}
          available={dataServ}
        />
      ) : (
        <div className="servicios">
          <span className="tituloServicios color-secondary">
            Servicios Contratados
          </span>
          <hr className="linea" />
          <div className="listaServicios">
            <span className="color-secondary">Esta es tu lista de servicios:</span>
            <div className="contenedorServicios">
              {loading ? (
                <div className="serviciosSkeleton">
                  {[1,2,3,4].map((n) => (
                    <div key={n} className="skeletonCard">
                      <div className="skeletonCircle" />
                      <div className="skeletonBody">
                        <div className="skeletonLine skeletonTitle" />
                        <div className="skeletonLine skeletonText" />
                      </div>
                      <div className="skeletonChevron" />
                    </div>
                  ))}
                </div>
              ) : (
                <>
                  {dataServ?.data?.map((serv, idx) => {
                    const letter = String.fromCharCode(65 + idx);

                    return (
                      <div key={serv.id || idx}
                        className={`cardServicio
              ${serv?.estado === "ACTIVO"
                            ? "blue"
                            : serv?.estado === "RETIRADO"
                              ? "red"
                              : serv?.estado === "POR RETIRAR"
                                ? "orange"
                                : serv?.estado === "SUSPENDIDO"
                                  ? "yellow"
                                  : serv?.estado === "TRANSFERIDO"
                                    ? "gray"
                                    : serv?.estado === "EXONERADO"
                                      ? "black"
                                      : ""
                          }`}
                        onClick={() => handleSelectServ(serv, letter)}
                      >
                        <div className="itemServicio">{letter}</div>
                        <div className="infoServicio">
                          <div className="contenServicio">
                            <div className="tituloServicio">
                              <div className="iconRed">
                                {serv.estado === "ACTIVO" ? (
                                  <FaWifi />
                                ) : serv.estado === "SUSPENDIDO" ? (
                                  <MdOutlineWifiPassword />
                                ) : serv.estado === "RETIRADO" ? (
                                  <MdOutlinePowerOff />
                                ) : serv.estado === "POR RETIRAR" ? (
                                  <MdOutlineWifiOff />
                                ) : serv.estado === "EXONERADO" ? (
                                  <RiMedalLine />
                                ) : serv.estado === "TRANSFERIDO" ? (
                                  <MdNetworkCheck />
                                ) : null}
                              </div>
                              <span className="spanDireccion">{capitalize(serv.zona.valor)}

                              </span>
                            </div>
                            <span className="direcServicio spanDireccion">
                              {capitalize(serv?.dir_calle)}, {serv?.dir_local_edificio}, {serv?.dir_referencia}
                            </span>
                          </div>
                          <div className="iconRight d-flex align-items-center">
                            <div
                              className="icon-container pending-wrapper"
                              onClick={() => navigate('/pagos')}
                            >
                              {serv?.tipo_servicio == "Pyme" ? (
                                <MdStore />
                              ) : serv?.tipo_servicio == "Corporativo" ? (
                                <MdOutlineFactory />
                              ) : (
                                <AiOutlineGlobal />
                              )}

                              {/* Icono de alerta con estilos CSS */}
                              {serv?.pending && serv.pending.length > 0 && (
                                <div className="boxAlertFill">
                                <GoAlertFill 
                                  className="pago-alerta-icono"
                                  title={serv.pending.length === 1
                                    ? "Tiene 1 documento pendiente por pagar"
                                    : `Tiene ${serv.pending.length} documentos pendientes por pagar`
                                  }
                                />
                              </div>)}
                            </div>
                            <FaChevronRight className="chevron-mobile ms-sm-4" />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      )}
      {loading ? (
        <div className="contenedorInformacionS skeleton">
          <div className="bienvenida">
            <div className="skeletonLine skeletonWelcomeLine" />
            <div className="skeletonLine skeletonWelcomeLine skeletonWelcomeLine--short" />
          </div>
          <div className="informacionServicios">
            <div className="informacion">
              <div className="skeletonLine skeletonInfoLine" />
              <div className="skeletonLine skeletonInfoLine skeletonInfoLine--short" />
            </div>
            <div className="imagen skeletonImg" />
          </div>
        </div>
      ) : (
      <div className="contenedorInformacionS color-secondary">
        <div className="bienvenida">
          <span>Bienvenido nuevamente,</span>
          <span>{userName}</span>
        </div>
        <div className="informacionServicios">
          <div className="informacion">
            <span>Gestiona sin limites tu plan, pagos y servicios</span>
            <span>Descarga la aplicacion y gestiona tus planes sin limites.</span>
          </div>
          <div className="imagen">
            <img src={imgInicio} alt="inicio" />
          </div>
        </div>
      </div>
      )}
    </div>
  );
};

export default Home;
